/**
 * Defines state for shortcut filter buttons
 */
export var ShortcutFilterButtonState;
(function (ShortcutFilterButtonState) {
    /**
     * Current filter button
     */
    ShortcutFilterButtonState["Active"] = "active";
    /**
     * Default filter button
     */
    ShortcutFilterButtonState["Default"] = "default";
    /**
     * Disabled filter button
     */
    ShortcutFilterButtonState["Disabled"] = "disabled";
})(ShortcutFilterButtonState || (ShortcutFilterButtonState = {}));
